<template lang="pug">
    .content-inner.agents
        aiq-tabs(:model-value="$route.name" @tab-click="tabChange" type="border-card")
            aiq-tab-pane(v-for="tab in displayTabs"
                        :key="tab.name"
                        :label="tab.label"
                        :name="tab.name")
            router-view
</template>

<script>
import get from 'lodash/get';
import featureFlags from '@/store/modules/featureFlags';


const baseResource = '/settings/smartdrive';
const buildResourcePath = (resource) => `${baseResource}/${resource}`;

const showSmartControl = get(featureFlags, 'state.FEATURE_FLAGS.SHOW_SMART_CONTROL', false);

export default {
  name: 'Smart Drive',
  data() {
    return {
      tabs: [
        {
          name: 'Smart Drive List',
          label: this.$t('settings_tab.smart_drive_tab.manage.name'),
          resource: baseResource,
        },
        ...(showSmartControl ? [
          {
            name: 'SmartControl',
            label: this.$t('settings_tab.admin_tab.smart_control.smart_control'),
            resource: buildResourcePath('smart_control'),
          },
          {
            name: 'Rules',
            label: this.$t('settings_tab.admin_tab.smart_control.rules'),
            resource: buildResourcePath('rules'),
          },
        ] : []),

      ],
    };
  },
  computed: {
    displayTabs() {
      return this.tabs.filter(tab => (tab.public || this.canView(tab.resource)));
    },
  },
  created() {
    const isEditor = get(this.$route, 'meta.isEditor', false);
    const exist = this.tabs.find(tab =>
      this.$route.matched.some(r => r.name === tab.name,

      ));

    if (!isEditor && !exist) {
      this.tabChange({ index: 0 });
    }
  },
  methods: {
    tabChange({ index }) {
      const currentTab = this.displayTabs[index];
      if (currentTab.name !== this.$route.name) {
        this.$router.push(currentTab);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .el-tab-pane .content-inner{
    padding: 0;
  }
</style>